import React from 'react';

/**
 * Shared error display used by ErrorPage, DmsErrorPage, and the Appointment screen.
 * Renders the common error header (caution icon + title) and any body content
 * passed in as children.
 *
 * @param {string} title - Text shown in the error header.
 * @param {React.ReactNode} children - Optional body content rendered under the header.
 * @param {string} className - Optional extra class for context-specific styling.
 */
const ErrorDisplay = ({ title, children, className }) => (
    <div className={`error-page-container${className ? ` ${className}` : ''}`}>
        <div className="error-message-header bold">
            <div className="error-icon icon alert-caution-red" />
            <div className="error-message-sorry headline3">{title}</div>
        </div>
        {children}
    </div>
);

export default ErrorDisplay;
